import { Box, Typography } from '@mui/material';

export const YoutubeEmbed = ({ videoUrl, title }: { videoUrl: string; title: string }) => {
  const isShorts = videoUrl.includes('/shorts/');
  const videoId = isShorts
    ? videoUrl.split('/shorts/')[1]?.split('?')[0]
    : videoUrl.split('v=')[1]?.split('&')[0];
  const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

  return (
    <Box
      sx={{
        mb: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: isShorts ? 'center' : 'stretch',
      }}
    >
      <Typography
        variant="body1"
        color="primary"
        fontWeight={700}
        sx={{ display: 'block', mb: 0.5 }}
      >
        {title}
      </Typography>
      <iframe
        style={
          isShorts
            ? { width: '50%', aspectRatio: '9/16', border: 'none', display: 'block' }
            : { width: '100%', aspectRatio: '16/9', border: 'none', display: 'block' }
        }
        src={embedUrl}
        frameBorder="0"
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </Box>
  );
};
